<template>
  <div class="information-panel">
    <!-- 空 -->
    <div class="empty" v-if="!list.length">
      <img src="@/assets/empty.png" />
      <div>暂无患者资料</div>
    </div>
    <div
      class="cell-list"
      v-for="(item, index) in list"
      :key="index"
      @click="operation(item)"
    >
      <div class="info">
        <div class="name">
          <span
            >{{ item.patientName }} · {{ item.patientSex == 1 ? '男' : '女' }} ·
            {{ item.patientAge }}</span
          >
        </div>
        <div class="cell m-b-10">
          <span class="label">身份证：</span>
          <span class="value">{{ item.patientIdentityCard }}</span>
        </div>
        <div class="cell">
          <span class="label">手机号：</span>
          <span class="value">{{ item.patientMobile }}</span>
        </div>
      </div>
      <div class="operation">
        <div class="item del" @click.stop="del(item)">删除</div>
        <div class="item edit" @click.stop="add(item)">查看</div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="information-bottom" v-if="list.length < 10">
      <button class="add-btn" @click="add">新增患者资料</button>
    </div>
  </div>
</template>

<script>
import request from '@/services/doctor';
import Vue from 'vue';
import { Dialog, Toast } from 'vant';
Vue.use(Dialog).use(Toast);
import eventBus from './bus.js';

export default {
  data() {
    return {
      type: undefined,
      list: [],
    };
  },
  mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.loadData();
  },
  methods: {
    loadData() {
      request
        .patientList(this.$store.getters.getUserInfo.patientId)
        .then((res) => {
          this.list = res.data.data || [];
          
        });
    },
    del(item) {
      Dialog.confirm({
        message: '是否确认“删除”',
      })
        .then(() => {
            request.delThePatient(item.id).then(res => {
                Toast.success('删除成功~');
                this.loadData();
            }, err => {
                Toast.fail('删除失败');
            })
        })
        .catch(() => {});
    },
    add(item) {
      if (item) {
        this.$router.push({
          name: 'information-edit',
          query: {
            id: item.id
          }
        });
      } else {
        this.$router.push({
          name: 'information-edit',
        });
      }
    },
    operation(item) {
      if (!this.type) return;
      let params = {
        patient_name: item.patientName,
        patient_age: item.patientAge,
        patient_sex: item.patientSex,
        patient_mobile: item.patientMobile,
        patient_card: item.patientIdentityCard,
        patient_allergies:item.patientAllergies,
        patient_Illness:item.patientIllness
      }
      
      eventBus.$emit('userInfo', params);
      console.log('params112',params)
      eventBus.$emit('userNoInfo', false);

      this.$router.back();
    }
  },
};
</script>

<style lang="less">
.information-panel {
  .m-b-10 {
    margin-bottom: 10px;
  }

  background: #f4f5f7;
  min-height: 100vh;
  padding: 15px 10px 0;
  padding-bottom: calc(70px + env(safe-area-inset-bottom));
  .cell-list {
    border-radius: 8px;
    background: white;
    margin-bottom: 10px;
    .name {
      color: #333333;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .info {
      padding: 15px;
      .cell {
        color: #595959;
      }
    }
    .operation {
      border-top: 1px solid #e5e5e5;
      display: flex;
      justify-content: space-between;
      height: 40px;
      .item {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        &.del {
          border-right: 1px solid #e5e5e5;
          color: #fa6400;
        }
        &.edit {
          color: #208fe3;
        }
      }
    }
  }
}
.information-bottom {
  padding: 10px;
  position: fixed;
  width: 100%;
  left: 0;
  box-sizing: border-box;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(247, 247, 247, 0) 0%,
    #f7f7f7 100%,
    #f7f7f7 100%
  );
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  .add-btn {
    width: 100%;
    outline: none;
    border: none;
    background: #208fe3;
    color: white;
    border-radius: 4px;
    height: 44px;
    font-size: 18px;
  }
}
.empty {
  padding-top: 100px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  image {
    width: 98px;
    height: 98px;
  }
  color: #a6a6a6;
  font-size: 16px;
}
.van-dialog {
    border-radius: 8px !important;
}
</style>